var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"exhibit"},[_c('ExhibitBanner'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('GoBackFooter',{attrs:{"routeItem":{ text: _vm.text, arrowString: '&#10230;', routeObj: { name: _vm.link } }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }